import React, { HTMLAttributes } from "react";
import isExternalLink from "utils/isExternalLink";
import NewTabLink from "components/links/NewTabLink";
import RouterLink from "components/links/RouterLink";

interface IProps extends HTMLAttributes<HTMLDivElement> {
    to?: string;
}

export default function LinkableItem(props: IProps) {
    const { children, to, ...rest } = props;

    if (typeof to === "undefined") return <div {...rest}>{children}</div>;

    const underline = "hover";

    if (isExternalLink(to))
        return (
            <div {...rest}>
                <NewTabLink href={to} underline={underline} style={{ color: "inherit" }}>
                    {children}
                </NewTabLink>
            </div>
        );

    return (
        <div {...rest}>
            <RouterLink to={to} underline={underline}>
                {children}
            </RouterLink>
        </div>
    );
}
